import React from "react";

const PrivacyPolicy = (props) => {

  const checkboxHandler = () => {
    props.updatePrivacyPoliciesState(props.index);
  }

  return (
    <div className={'form-group'}>
      <div className={'form-check'}>
        <input
          id={'privacyPolicy_' + props.index}
          className={'form-check-input'}
          type="checkbox"
          required
          onClick={checkboxHandler}
        />
        <label htmlFor={'privacyPolicy_' + props.index} dangerouslySetInnerHTML={{ __html: props.label }} />
        <small
          id={'checkboxError_' + props.index}
          className="error-message-small text-danger form-text"
        >
          &nbsp;
        </small>
      </div>
    </div>
  );
}

export default PrivacyPolicy
